import styled from 'styled-components';

export const ScCvvMethodCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  background-color: ${({ theme }) => theme.grayColor6};
  padding: 8px;
  border-radius: 12px;
  gap: 8px;
  width: 216px;
  height: 190px;
  right: -12px;
  bottom: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5), 0px 10px 30px rgba(0, 0, 0, 0.5);
  .title {
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
  }
  .img-wrapper {
    display: flex;
    max-width: 200px;
  }
  .img {
    display: block;
    max-width: 200px;
  }
`;
